import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PersonRoleStore } from '@app/stores/person-role/person-role.store';
import { GetLocalizedPipe } from '@app/pipes/get-localized.pipe';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TitleNameFormComponent } from '../title-name-form/title-name-form.component';
import { GuarantorFormGroup } from './guarantor-form.helper';

@Component({
  selector: 'app-guarantor-form',
  imports: [
    ReactiveFormsModule,
    ValidatedInputComponent,
    ValidatedDropdownComponent,
    TitleNameFormComponent,
    GetLocalizedPipe,
  ],
  templateUrl: './guarantor-form.component.html',
  styleUrl: './guarantor-form.component.scss',
})
export class GuarantorFormComponent {
  protected personRoleStore = inject(PersonRoleStore);
  formGroup = input.required<FormGroup<GuarantorFormGroup>>();
  disabled = input<boolean>(false);
}
